import React from "react";
import { DropdownOption } from "./types";

interface DropdownButtonProps {
  isOpen: boolean;
  disabled: boolean;
  selectedLabels: string;
  placeholder: string;
  multiSelect: boolean;
  value: string | string[];
  options: DropdownOption[];
  onClick: () => void;
}

export const DropdownButton: React.FC<DropdownButtonProps> = ({
  isOpen,
  disabled,
  selectedLabels,
  placeholder,
  multiSelect,
  value,
  options,
  onClick,
}) => {
  const getDisplayValue = () => {
    const formatLabel = (label: string) => {
      if (label.includes(" | ")) {
        return label.split(" | ")[0];
      }
      return label;
    };

    if (multiSelect && Array.isArray(value) && value.length > 0) {
      // Get the names of selected options
      const selectedOptions = options.filter((opt) =>
        value.includes(opt.value)
      );
      const names = selectedOptions
        .map((opt) => formatLabel(opt.label))
        .join(", ");

      // Display format: "Name1, Name2 (+3 more)" or just names if few enough
      if (selectedOptions.length <= 5) {
        return names;
      }

      const firstTwo = selectedOptions
        .slice(0, 5)
        .map((opt) => formatLabel(opt.label))
        .join(", ");
      const remaining = selectedOptions.length - 5;
      return `${firstTwo} (+${remaining} more)`;
    }
    return formatLabel(selectedLabels) || placeholder;
  };

  const displayValue = getDisplayValue();
  const hasSelection = multiSelect
    ? Array.isArray(value) && value.length > 0
    : !!selectedLabels;
  // const getDisplayValue = () => {
  //   if (multiSelect && Array.isArray(value) && value.length > 0) {
  //     return `${value.length} selected`;
  //   }
  //   return selectedLabels || placeholder;
  // };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-expanded={isOpen}
      aria-haspopup="listbox"
      className={`
        w-full px-4 py-3 text-left bg-white text-15 border border-primary rounded-[10px] shadow-sm
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
        transition-all duration-200 ease-in-out mb-2
        ${
          disabled
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "hover:border-gray-400 cursor-pointer"
        }
        ${isOpen ? "ring-2 ring-blue-500 border-blue-500" : ""}
      `}
    >
      <div className="flex items-center justify-between">
        <span
          className={`truncate ${!hasSelection ? "text-gray-500" : ""}`}
          title={displayValue}
        >
          {displayValue}
        </span>
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform duration-200 flex-shrink-0 ml-2 ${
            isOpen ? "transform rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </button>
  );
};
